// Carrito Naturalie: agrega/cambia líneas por AJAX y re-renderiza el drawer con la
// Section Rendering API en la misma respuesta (parámetro `sections`).
(() => {
  const root = window.Shopify?.routes?.root || '/';

  const drawer = () => document.querySelector('[data-nat-drawer]');

  function render(sections) {
    const el = drawer();
    if (!el || !sections) return;
    const html = sections[el.dataset.sectionId];
    if (!html) return;
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-nat-drawer-content]');
    el.querySelector('[data-nat-drawer-content]').replaceWith(fresh);
  }

  function setCount(count) {
    document.querySelectorAll('[data-nat-cart-count]').forEach((n) => (n.textContent = count));
  }

  async function post(path, body) {
    const el = drawer();
    const res = await fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: el ? [el.dataset.sectionId] : [], sections_url: window.location.pathname }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'No se pudo actualizar el carrito');
    return data;
  }

  async function add(items) {
    const data = await post('cart/add.js', { items });
    render(data.sections);
    const cart = await (await fetch(root + 'cart.js')).json();
    setCount(cart.item_count);
    open();
    return cart;
  }

  async function change(line, quantity) {
    const cart = await post('cart/change.js', { line, quantity });
    render(cart.sections);
    setCount(cart.item_count);
    return cart;
  }

  let lastFocus = null;

  function open() {
    const el = drawer();
    if (!el || el.open) return;
    lastFocus = document.activeElement;
    el.showModal();
    // Horizon scrollea en .page-wrapper; este atributo lo bloquea mientras el drawer está abierto.
    document.documentElement.setAttribute('scroll-lock', '');
  }

  function close() {
    const el = drawer();
    if (!el || !el.open) return;
    el.classList.add('is-closing');
    const done = () => {
      el.classList.remove('is-closing');
      el.close();
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) done();
    else el.addEventListener('animationend', done, { once: true });
  }

  document.addEventListener('click', (event) => {
    const el = drawer();
    if (!el) return;

    if (event.target.closest('[data-nat-cart-open]')) {
      event.preventDefault();
      open();
      return;
    }
    if (event.target.closest('[data-nat-drawer-close]') || event.target === el) {
      close();
      return;
    }
    const stepper = event.target.closest('[data-nat-line-qty]');
    if (stepper) {
      const line = Number(stepper.dataset.line);
      const qty = Math.max(0, Number(stepper.dataset.current) + Number(stepper.dataset.natLineQty));
      el.setAttribute('aria-busy', 'true');
      change(line, qty).catch((e) => alertIn(el, e.message)).finally(() => el.removeAttribute('aria-busy'));
    }
  });

  function alertIn(el, message) {
    const box = el.querySelector('[data-nat-drawer-error]');
    if (box) box.textContent = message;
  }

  document.addEventListener('close', (event) => {
    if (event.target.matches?.('[data-nat-drawer]')) {
      document.documentElement.removeAttribute('scroll-lock');
      lastFocus?.focus?.();
    }
  }, true);

  // Esc dispara `cancel` en el dialog: se intercepta para cerrar con la animación de salida.
  document.addEventListener('cancel', (event) => {
    if (event.target.matches?.('[data-nat-drawer]')) {
      event.preventDefault();
      close();
    }
  }, true);

  // "Agregar" de las tarjetas de producto (snippets/nat-product-card.liquid), en cualquier página.
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-nat-quick-add]');
    if (!button || button.disabled) return;
    const label = button.querySelector('[data-nat-quick-label]');
    button.disabled = true;
    label.textContent = 'Agregando…';
    try {
      await add([{ id: Number(button.dataset.natQuickAdd), quantity: 1 }]);
      label.textContent = 'Agregado ✓';
    } catch (error) {
      label.textContent = 'No se pudo agregar';
      button.title = error.message;
    } finally {
      button.disabled = false;
      setTimeout(() => (label.textContent = 'Agregar'), 2200);
    }
  });

  // Mobile: la hoja se cierra deslizándola hacia abajo desde el encabezado (como en Rex).
  let arrastre = null;
  document.addEventListener('touchstart', (event) => {
    const grab = event.target.closest('[data-nat-drawer-grab]');
    const el = drawer();
    if (!grab || !el?.open || !window.matchMedia('(max-width: 749px)').matches) return;
    if (event.target.closest('button')) return;
    arrastre = { y: event.touches[0].clientY, dy: 0 };
    el.style.transition = 'none';
  }, { passive: true });
  document.addEventListener('touchmove', (event) => {
    if (!arrastre) return;
    arrastre.dy = Math.max(0, event.touches[0].clientY - arrastre.y);
    drawer().style.transform = `translateY(${arrastre.dy}px)`;
  }, { passive: true });
  document.addEventListener('touchend', () => {
    if (!arrastre) return;
    const el = drawer();
    const cerrar = arrastre.dy > 90;
    arrastre = null;
    el.style.transition = 'transform .2s ease';
    el.style.transform = cerrar ? 'translateY(100%)' : '';
    setTimeout(() => {
      el.style.transition = '';
      if (cerrar) { el.close(); el.style.transform = ''; }
    }, 200);
  });

  window.NatCart = { add, change, open, close };
})();
